<template>
  <div>
    <section class="container mx-auto max-w-6xl">
      <HeroWithVideo
        :content="homepageData.video"
        :isLoading="isLoadingFlowStart"
        @cta:click="getStarted"
      />
    </section>
    <section
      class="bg-background-light mt-8 md:mt-0 pt-8 px-6 pb-6 md:pb-16 md:px-0"
    >
      <div
        class="container mx-auto max-w-6xl md:grid md:grid-cols-12 md:gap-8 md:px-4 items-center"
      >
        <h1
          class="mb-4 md:col-span-4 text-26 md:text-32 text-primary-dark text-center md:text-left"
        >
          {{ homepageData.heading }}
        </h1>
        <div class="md:col-span-1"></div>
        <div class="md:col-span-7 text-sm md:text-base text-center md:text-left pb-6">
          <p class="text-black-medium-emphasis">{{ homepageData.instructions }}</p>
          <br />
          <p class="font-bold text-gray-darkest">{{ homepageData.disclaimer }}</p>
        </div>
        <StepCard
          v-for="step in homepageData.steps"
          :key="step.uid"
          :count="step.number"
          :title="step.heading"
          :description="step.description"
          class="mb-4 md:mb-0 md:col-span-4"
        />
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useFlow, useGlobal } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import { HeroWithVideo, StepCard } from '@/components'
import { storeToRefs } from 'pinia'
export default defineComponent({
  name: 'Home',
  components: {
    HeroWithVideo,
    StepCard
  },
  setup () {
    const router = useRouter()
    const route = useRoute()

    const { homepageData } = storeToRefs(useGlobal())
    const { startFlow } = useFlow()
    const isLoadingFlowStart = ref(false)

    const getStarted = async () => {
      isLoadingFlowStart.value = true
      await startFlow()
      router.push({
        path: 'flow',
        query: { ...route.query }
      })
    }

    return { homepageData, isLoadingFlowStart, getStarted }
  }
})
</script>
